var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglearrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_206974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5751 8.79053L8.761 16.7905H0L6.82109 8.79053L0 0.790527H8.75402L15.5751 8.79053Z",
    fill: "url(#paint0_linear_4390_206974)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.9985 8.79056L13.6476 13.8968H8.05469L12.409 8.79056L8.05469 3.68433H13.6441L17.9985 8.79056Z",
    fill: "url(#paint1_linear_4390_206974)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4390_206974",
    x1: 12.5955,
    y1: 8.79053,
    x2: -23.6069,
    y2: 8.79053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4390_206974",
    x1: 4.11555,
    y1: 0.790562,
    x2: 15.6347,
    y2: 8.94093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_206974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(0 0.790527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglearrow);
export default __webpack_public_path__ + "static/media/singlearrow.f2d320f508b3ecb5ae887b962a2c670c.svg";
export { ForwardRef as ReactComponent };